<template>
  <div class='EnbNaveLink0302' @click="push"
  :style="{
    '--hover-bg': color,
    'color': Prefes.nave.corFont,
    'font-family': Prefes.nave.font,
    fontStyle: parseInt(Prefes.nave.fontStyle) ? 'italic' : '',
    fontWeight: parseInt(Prefes.nave.fontBold) ? 'bold' : '',
    textDecoration: parseInt(Prefes.nave.textDecoration) ? 'underline' : '',
    fontSize: Prefes.nave.fontHeight + 'px'
    }">
    <component tam="20px" :color="Prefes.nave.corFont" :is="data.icon"/>
    {{ data.name }}
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { icons } from '@/components/icons'
export default {
  name: 'EnbNaveLink0302',
  props: ['data', 'color'],
  components: { ...icons },
  computed: {
    ...mapGetters(['FilterProdStore', 'Prefes'])
  },
  methods: {
    ...mapActions(['changeFilterProdStore', 'GetStoreProducts', 'Loading']),
    async push () {
      this.Loading(true)
      this.$router.push(`/site/${this.data.link}`)
      this.changeFilterProdStore({ categoria: this.data.link })
        .then(() => {
          this.GetStoreProducts({ params: { last: [], limit: 8, categoria: this.data.link }, init: true })
            .then(() => {
              this.Loading(false)
              // document.getElementById('content').scrollIntoView({ 
              //   behavior: "smooth",
              //   block: "start"
              // })
            })
        })
    }
  }
}
</script>

<style scoped>
.EnbNaveLink0302 {
  padding: 10px;
  cursor: pointer;
  animation: Out 0.7s forwards;
  color: #FFFFFF;
  margin-left: 2px;
  border-radius: 5px;
  display: flex;
  align-items: center;
}

.EnbNaveLink0302:hover {
  animation: In 1s forwards;
}

@keyframes In {
  0% {
    background-color: transparent;
  }
  100% {
    background-color: var(--hover-bg);
  }
}
@keyframes Out {
  0% {
    background-color: var(--hover-bg);
  }
  100% {
    background-color: transparent;
  }
}
</style>
